import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { get, post } from "../../utils/apiManager";
import { baseURL } from "../../config/config";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import Pagination from 'react-js-pagination';
import { useForm } from "react-hook-form";
import SuccessModal from "../../components/SuccessModal";

const Index = () => {
  const { register, handleSubmit, getValues, setValue } = useForm();
  const [features, setFeatures] = useState([]);
  const Navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [pageData, setPageData] = useState({ page: 1, perPage: 25 });
  const [modalData, setModalData] = useState({ message: "", show: false });

  useEffect(() => { getAllFeatures(); }, [pageData]);

  const getAllFeatures = () => {
    get(`/plan-feature?page=${pageData.page}&perPage=${pageData.perPage}&searchItem=${getValues("searchItem") || ""}`)
      .then((res) => { setFeatures(res?.data || res?.datas || []); setCount(res?.pages || 0); })
      .catch((err) => console.log(err));
  };

  const changeStatus = (id, status) => {
    post(`${baseURL}/plan-feature/status`, { id, status: !status })
      .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllFeatures(); } else toast.error(res?.message); })
      .catch((err) => toast.error(err?.response?.data?.error));
  };

  const deleteHandler = (id) => {
    Swal.fire({ title: 'Are you sure?', text: 'This will delete the feature.', icon: 'warning', showCancelButton: true, confirmButtonColor: '#AD2429', cancelButtonColor: '#6b7a99', confirmButtonText: 'Yes, delete it!' })
      .then((result) => {
        if (result.isConfirmed) {
          post(`${baseURL}/plan-feature/delete`, { id })
            .then((res) => { if (res?.status) { setModalData({ message: res.message, show: true }); getAllFeatures(); } else toast.error(res?.message); })
            .catch((err) => toast.error(err?.response?.data?.error));
        }
      });
  };

  const pill = (active) => (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '3px 9px', borderRadius: 100, fontSize: 11, fontWeight: 700, background: active ? '#dcfce7' : '#fee2e2', color: active ? '#15803d' : '#b91c1c' }}>
      <span style={{ fontSize: 7 }}>●</span>{active ? 'Active' : 'Inactive'}
    </span>
  );

  const thS = { padding: '10px 14px', fontSize: 11, fontWeight: 700, letterSpacing: '0.07em', textTransform: 'uppercase', color: '#9aa5c0', textAlign: 'left', borderBottom: '1px solid #edf0f7', background: '#f8f9fc', whiteSpace: 'nowrap' };
  const tdS = { padding: '12px 14px', fontSize: 14, color: '#3a4a6a', borderBottom: '1px solid #f0f2f8', verticalAlign: 'middle' };

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #edf0f7', boxShadow: '0 1px 4px rgba(26,39,68,.05)', overflow: 'hidden' }}>

        {/* Header */}
        <div style={{ padding: '18px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #edf0f7' }}>
          <div>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#0a1628', margin: 0 }}>Plan Features</h3>
            <p style={{ fontSize: 13, color: '#9aa5c0', margin: '3px 0 0' }}>Features that can be assigned to pricing plans</p>
          </div>
          <Link to="/admin/plan-features/add" style={{ textDecoration: 'none' }}>
            <button style={{ background: '#AD2429', color: '#fff', border: 'none', borderRadius: 8, padding: '9px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}>
              + Add Feature
            </button>
          </Link>
        </div>

        {/* Search */}
        <div style={{ padding: '14px 24px', borderBottom: '1px solid #edf0f7', display: 'flex', gap: 10, alignItems: 'center', justifyContent: 'flex-end' }}>
          <input placeholder="Search features..." {...register("searchItem")} style={{ padding: '8px 14px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, color: '#0a1628', outline: 'none', width: 240, fontFamily: 'inherit' }} />
          <button onClick={() => getAllFeatures()} style={{ background: '#1a2744', color: '#fff', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Search</button>
          <button onClick={() => { setValue("searchItem", ""); getAllFeatures(); }} style={{ background: '#f0f2f8', color: '#5a6a8a', border: 'none', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Clear</button>
        </div>

        {/* Table */}
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['#', 'Feature Name', 'Description', 'Status', 'Actions'].map(h => <th key={h} style={thS}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {features?.length > 0 ? features.map((item, index) => (
                <tr key={item?._id} onMouseEnter={e => e.currentTarget.style.background = '#fafbfd'} onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                  <td style={{ ...tdS, color: '#9aa5c0', fontSize: 13 }}>{(pageData.page - 1) * pageData.perPage + index + 1}</td>
                  <td style={{ ...tdS, fontWeight: 600, color: '#0a1628' }}>{item?.name}</td>
                  <td style={{ ...tdS, color: '#6b7a99' }}>{item?.description?.length > 60 ? `${item.description.slice(0, 60)}...` : item?.description || '—'}</td>
                  <td style={tdS}>{pill(item?.isActive)}</td>
                  <td style={tdS}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={() => changeStatus(item._id, item?.isActive)} title={item?.isActive ? 'Deactivate' : 'Activate'}
                        style={{ width: 30, height: 30, borderRadius: 6, border: 'none', background: item?.isActive ? '#fee2e2' : '#dcfce7', color: item?.isActive ? '#b91c1c' : '#15803d', cursor: 'pointer', fontSize: 13 }}>
                        {item?.isActive ? '✕' : '✓'}
                      </button>
                      <button onClick={() => Navigate(`/admin/plan-features/edit?${item._id}`)} title="Edit"
                        style={{ width: 30, height: 30, borderRadius: 6, border: 'none', background: '#eff6ff', color: '#1d4ed8', cursor: 'pointer', fontSize: 13 }}>✎</button>
                      <button onClick={() => deleteHandler(item._id)} title="Delete"
                        style={{ width: 30, height: 30, borderRadius: 6, border: 'none', background: '#fee2e2', color: '#b91c1c', cursor: 'pointer', fontSize: 13 }}>🗑</button>
                    </div>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan={5} style={{ ...tdS, textAlign: 'center', padding: '48px', color: '#9aa5c0' }}>No features found</td></tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {features?.length > 0 && (
          <div style={{ padding: '14px 24px', borderTop: '1px solid #edf0f7', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontSize: 13, color: '#9aa5c0' }}>Page {pageData.page} · {pageData.perPage} per page</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <Pagination itemClass="page-item" linkClass="page-link" activePage={pageData.page} itemsCountPerPage={pageData.perPage} totalItemsCount={count} pageRangeDisplayed={5} onChange={(page) => setPageData(prev => ({ ...prev, page }))} />
              <select onChange={(e) => setPageData(prev => ({ ...prev, perPage: parseInt(e.target.value), page: 1 }))} style={{ padding: '6px 10px', borderRadius: 7, border: '1px solid #e2e8f0', fontSize: 13, color: '#3a4a6a', background: '#fff', fontFamily: 'inherit' }}>
                <option value="25">25</option><option value="50">50</option><option value="75">75</option><option value="100">100</option>
              </select>
            </div>
          </div>
        )}
      </div>
      <SuccessModal message={modalData?.message} showModal={modalData?.show} setShowModal={setModalData} />
    </div>
  );
};

export default Index;
